import React from 'react';

const TermsSection = () => {
  return (
    <section className="section" id="terms">
      <div className="section-scroll legal-scroll">
        <div className="section-content legal-content">
          <span className="section-kicker">Legal & compliance</span>
          <h2>Privacy Policy &amp;<br /><em>Messaging Terms</em></h2>
          
          <h3>Privacy Policy</h3>
          
          <p><strong>Effective Date:</strong> 8.25.2025<br/>
          <strong>Company:</strong> GOS TRANS<br/>
          <strong>Website:</strong> https://www.gostrans.com<br/>
          <strong>Email:</strong> dispatch@gostrans.com<br/>
          <strong>Phone:</strong> (312) 626-8383<br/>
          <strong>Fax:</strong> (312) 500-1914<br/>
          <strong>Address:</strong> 5015 Switch Grass Ln, Naperville, IL 6056</p>
          
          <p>GOS TRANS ("we," "our," or "us") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or when you interact with us through SMS/text messaging services.</p>
          
          <h4>1. Information We Collect</h4>
          <ul>
            <li><strong>Personal Information:</strong> Name, phone number, email address, fax number, and mailing address.</li>
            <li><strong>SMS/Text Information:</strong> Mobile number, message opt-in/opt-out records, message logs, and delivery data.</li>
            <li><strong>Website Usage Information:</strong> IP address, browser type, device type, and pages visited (collected automatically through cookies or analytics tools).</li>
          </ul>
          
          <p>We do not collect sensitive information such as Social Security numbers, banking details, or credit card information via our SMS/text services.</p>
          
          <h4>2. How We Use Your Information</h4>
          <ul>
            <li>Communicating with you about our services, dispatch updates, and company notices</li>
            <li>Providing SMS/text notifications related to loads, safety updates, and account information</li>
            <li>Improving website performance and user experience</li>
            <li>Responding to inquiries, requests, or customer service needs</li>
            <li>Complying with legal and regulatory requirements</li>
          </ul>
          
          <p>We will never sell, rent, or trade your personal information to third parties for marketing purposes.</p>
          
          <h4>3. SMS/Text Messaging Policy</h4>
          <p>By providing your mobile phone number, you consent to receive SMS/text messages from GOS TRANS.</p>
          <ul>
            <li>Message frequency may vary depending on your relationship with us.</li>
            <li>Message and data rates may apply depending on your mobile carrier.</li>
            <li>You can opt out at any time by replying STOP to any message.</li>
            <li>For help, reply HELP or contact us at dispatch@gostrans.com or (312) 626-8383.</li>
          </ul>
          
          <p>We comply with the Telephone Consumer Protection Act (TCPA) and CTIA guidelines.</p>
          
          <h4>4. Information Sharing</h4>
          <p>We may share your information only in these limited situations:</p>
          <ul>
            <li>With trusted service providers who assist with SMS delivery or website hosting</li>
            <li>When required by law, regulation, subpoena, or government request</li>
            <li>To protect the rights, property, or safety of GOS TRANS, our customers, or others</li>
          </ul>
          
          <h4>5. Data Security</h4>
          <p>We implement reasonable technical, administrative, and physical safeguards to protect your information. However, no transmission over the Internet or via SMS can be guaranteed 100% secure, and we cannot ensure absolute protection.</p>
          
          <h4>6. Data Retention</h4>
          <p>We retain personal information only as long as necessary to provide services or comply with legal obligations. SMS/text message records may be retained as required for compliance and dispute resolution.</p>
          
          <h4>7. Your Privacy Rights</h4>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request corrections or updates to your information</li>
            <li>Request deletion of your information, subject to legal requirements</li>
            <li>Opt out of receiving SMS/text messages at any time</li>
          </ul>
          
          <h4>8. Third-Party Links</h4>
          <p>Our website may include links to third-party websites. We are not responsible for the privacy practices or content of those websites. We encourage you to review their privacy policies.</p>
          
          <h4>9. Changes to This Privacy Policy</h4>
          <p>We may update this Privacy Policy at any time. Updates will be posted on this page with the revised "Effective Date." Continued use of our website or SMS services after changes are made indicates your acceptance of the updated policy.</p>
          
          <h4>10. Contact Us</h4>
          <p>If you have questions or concerns regarding this Privacy Policy or our data practices, please contact us:</p>
          
          <p><strong>GOS TRANS</strong><br/>
          5015 Switch Grass Ln<br/>
          Naperville, IL 6056<br/>
          <strong>Phone:</strong> (312) 626-8383<br/>
          <strong>Fax:</strong> (312) 500-1914<br/>
          <strong>Email:</strong> dispatch@gostrans.com<br/>
          <strong>Website:</strong> https://www.gostrans.com</p>
          
          <hr style={{margin: '2rem 0', border: '1px solid #ccc'}}/>
          
          <h3>SMS/Text Messaging Terms & Conditions</h3>
          
          <p><strong>Effective Date:</strong> 8.25.2025<br/>
          <strong>Company:</strong> GOS TRANS<br/>
          <strong>Website:</strong> https://www.gostrans.com<br/>
          <strong>Contact Email:</strong> dispatch@gostrans.com<br/>
          <strong>Phone:</strong> (312) 626-8383</p>
          
          <h4>1. Program Description</h4>
          <p>By opting in to the GOS TRANS SMS/Text Messaging Program, you agree to receive text messages from us regarding dispatch notifications, load updates, safety alerts, account information, and other company-related communications. Message frequency will vary depending on your interaction with our services.</p>
          
          <h4>2. Consent to Receive Messages</h4>
          <p>By providing your mobile phone number, you expressly consent to receive SMS/text messages from GOS TRANS. Consent is not required as a condition of purchasing services.</p>
          
          <h4>3. Cost and Carriers</h4>
          <ul>
            <li>Standard message and data rates may apply based on your mobile carrier plan.</li>
            <li>GOS TRANS is not responsible for any charges incurred by you for receiving SMS/text messages.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ul>
          
          <h4>4. Opt-Out Instructions</h4>
          <p>You may opt out of the SMS/Text Messaging Program at any time:</p>
          <ul>
            <li>Reply STOP to any message to cancel.</li>
            <li>After opting out, you will no longer receive SMS/text messages from GOS TRANS unless you re-enroll.</li>
          </ul>
          
          <h4>5. Support Instructions</h4>
          <p>For help with SMS/text messages:</p>
          <ul>
            <li>Reply HELP to any message</li>
            <li>Contact us at dispatch@gostrans.com or call (312) 626-8383</li>
          </ul>
          
          <h4>6. Privacy</h4>
          <p>Your information is protected under our Privacy Policy, available at: https://www.gostrans.com. We will never sell or rent your personal information to third parties.</p>
          
          <h4>7. Eligibility</h4>
          <ul>
            <li>You must be at least 18 years old to participate.</li>
            <li>By enrolling, you represent that you are the account holder for the mobile number provided or have permission to enroll the number.</li>
          </ul>
          
          <h4>8. Changes to Terms</h4>
          <p>We may revise these Terms & Conditions at any time. Updates will be posted at https://www.gostrans.com. Continued participation after changes constitutes acceptance of the revised Terms.</p>
          
          <h4>9. Contact Us</h4>
          <p>If you have any questions about these Terms & Conditions or the SMS/Text Messaging Program, you may contact us at:</p>
          
          <p><strong>GOS TRANS</strong><br/>
          5015 Switch Grass Ln<br/>
          Naperville, IL 6056<br/>
          <strong>Phone:</strong> (312) 626-8383<br/>
          <strong>Fax:</strong> (312) 500-1914<br/>
          <strong>Email:</strong> dispatch@gostrans.com<br/>
          <strong>Website:</strong> https://www.gostrans.com</p>
        </div>
      </div>
    </section>
  );
};

export default TermsSection; 